
<template>
   <v-dialog
      v-model="showHelp"
      max-width="600"
    >
      <v-card class="pb-3 mb-0">
        <v-toolbar color="green darken-3" dark>
          <v-toolbar-title class="headline">About Room Attribute Search</v-toolbar-title>
        </v-toolbar>

        <v-card-text class="ml-2 pr-4 mt-3">
          Formulate a search by first selecting a Basic Room Attribute or a Room Amenity.<br>Add to the search criteria.  
          <br><br>Multiple criteria can be strung together by selecting another attribute or amenity and clicking Add again.
          <br><br>Press Search after building critera.

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-layout align-items-center>
            <v-btn color="green darken-1"
              flat="flat"
              @click="setShowHelpRoomAttributeSearch(false)"
            > OK
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'HelpRoomCollections',

  computed: {
      showHelp: {
          get () { return this.$store.state.ui.showHelpRoomAttributeSearch },
          set (value) { this.setShowHelpRoomAttributeSearch(false) }
      },
  },
  
  methods : {
      ...mapMutations(['setShowHelpRoomAttributeSearch',]),
  },
}

</script>





// WEBPACK FOOTER //
// src/components/help/HelpRoomAttributeSearch.vue